import { Link } from "react-router-dom";

interface BreadcrumbItem {
	label: string;
	href?: string;
}

interface AdminBreadcrumbProps {
	items: BreadcrumbItem[];
}

export function AdminBreadcrumb({ items }: AdminBreadcrumbProps) {
	return (
		<nav className="mb-6 flex items-center gap-2 text-sm">
			{items.map((item, index) => {
				const isLast = index === items.length - 1;
				return (
					<span key={item.label} className="flex items-center gap-2">
						{index > 0 && <span className="text-muted">/</span>}
						{isLast || !item.href ? (
							<span className={isLast ? "text-primary" : "text-secondary"}>{item.label}</span>
						) : (
							<Link to={item.href} className="text-secondary transition-colors hover:text-primary">
								{item.label}
							</Link>
						)}
					</span>
				);
			})}
		</nav>
	);
}
